export enum ProductionListScope {
  ORDER = 'ORDER',

  MULTI = 'MULTI',
}
